import { FC } from "react";
import styled from "styled-components";

interface OrangePlayFullProps {
  viewView: string;
  viewHeight: string;
  marginTop?: string;
  marginBottom?: string;
  strokeWidth?: string;
}

interface StyledSVGProps {
  marginTop?: string;
  marginBottom?: string;
}

const StyledSVG = styled.svg<StyledSVGProps>`
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "1em"};
`;

export const OrangePlayFull: FC<OrangePlayFullProps> = ({
  viewView,
  viewHeight,
  marginTop,
  marginBottom,
  strokeWidth = 6
}) => (
  <StyledSVG
    width={viewView}
    height={viewHeight}
    viewBox="0 0 252 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    marginTop={marginTop}
    marginBottom={marginBottom}
  >
    <path
      d="M4.18164 8L129.045 4L247.818 8"
      stroke="#FFEDE3"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StyledSVG>
);
